/* TLY v3 Shop All / category page - progressive enhancement (Agent 5, 2026-10-25).
   Every control in the section is a real link or a GET form and works without this file. This script:
   - turns clicks on [data-t3-nav] links (tiles, quick-filter bar, sidebar options, Clear, pagination) and the Sort select into
     Section Rendering API requests: fetch(url + section_id=<section.id>) and swaps the panel (or the whole page body when the
     category changes), re-plays the .t3-in animation, announces the count in a polite live region, history.pushState + popstate.
   - aborts the in-flight request when a newer one starts; any failure falls back to a normal navigation.
   - phone: opens/closes the filter sheet (focus trap, Escape, scroll lock). No Apply button anywhere. */
(function () {
  'use strict';
  /* T3H (WP1) start: sticky header headroom = condensed header height + 12 */
  function t3hOff() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--t3h-cond')); return (v > 0 ? v : 68) + 12; }
  /* T3H (WP1) end */
  var root = document.querySelector('[data-t3-sa]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var mq = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var ctrl = null;
  var opener = null;

  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  try { if (!history.state || !history.state.t3) history.replaceState({ t3: 1 }, '', location.href); } catch (e) {}

  /* ---------- Section Rendering API ---------- */
  function go(url, src, noPush) {
    if (!window.fetch || !window.DOMParser) { location.href = url; return; }
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var mine = ctrl;
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', sectionId);
    var res = q('.t3-res');
    if (res) res.classList.add('t3-busy');
    var focusKey = src && src.getAttribute ? src.getAttribute('data-t3k') : null;
    var fromPager = !!(src && src.closest && (src.closest('.t3-pg') || src.closest('.t3-tiles')));

    fetch(u.toString(), { credentials: 'same-origin', signal: mine ? mine.signal : undefined, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (mine !== ctrl) return; // a newer request replaced this one
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.querySelector('[data-t3-sa]');
        if (!nr) { location.href = url; return; }
        var samePage = nr.getAttribute('data-page') === root.getAttribute('data-page') && root.getAttribute('data-page') !== 'other';
        if (samePage) {
          // same category: swap sidebar + bar + grid (and the breadcrumb, which names the quick-filter sub-collection)
          var cur = q('[data-t3-panel]'), nxt = nr.querySelector('[data-t3-panel]');
          if (!cur || !nxt) { location.href = url; return; }
          cur.innerHTML = nxt.innerHTML;
          var cc = q('.t3-crumb'), nc = nr.querySelector('.t3-crumb');
          if (cc && nc) cc.innerHTML = nc.innerHTML;
        } else {
          var body = q('[data-t3-body]'), nb = nr.querySelector('[data-t3-body]');
          if (!body || !nb) { location.href = url; return; }
          body.innerHTML = nb.innerHTML;
          root.setAttribute('data-page', nr.getAttribute('data-page'));
          root.setAttribute('data-cat', nr.getAttribute('data-cat'));
        }
        var t = nr.getAttribute('data-title');
        if (t) document.title = t;
        if (!noPush) { try { history.pushState({ t3: 1 }, '', url); } catch (e) {} }
        after(focusKey, fromPager);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = url;
      });
  }

  function after(focusKey, scrollTop) {
    var res = q('.t3-res');
    if (res) res.classList.remove('t3-busy');
    // replay the card entrance animation (.t3-in is defined in tly-v3.css)
    qa('.t3-card').forEach(function (c) { c.classList.remove('t3-in'); void c.offsetWidth; c.classList.add('t3-in'); });
    // announce the count
    var n = q('.t3-n');
    var live = q('[data-t3-live]');
    if (n && live) {
      live.textContent = '';
      var msg = n.textContent + (n.textContent === '1' ? ' product shown' : ' products shown');
      setTimeout(function () { live.textContent = msg; }, 60);
    }
    if (focusKey) {
      var el = null;
      qa('[data-t3k]').forEach(function (x) { if (x.getAttribute('data-t3k') === focusKey) el = x; });
      if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }
    if (scrollTop) {
      var p = q('#t3-panel');
      if (p) {
        var top = p.getBoundingClientRect().top;
        if (top < t3hOff()) window.scrollTo({ top: window.pageYOffset + top - t3hOff(), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    }
    centerSelected();
  }

  function updateFade() {
    var g = q('.t3-qgrp');
    if (g) g.classList.toggle('t3-more', g.scrollWidth - g.clientWidth - g.scrollLeft > 2);
  }
  root.addEventListener('scroll', function (e) { if (e.target.classList && e.target.classList.contains('t3-qgrp')) updateFade(); }, true);
  window.addEventListener('resize', updateFade);
  function centerSelected() {
    var g = q('.t3-qgrp'), s = g && g.querySelector('.t3-sel');
    if (g && s && g.scrollWidth > g.clientWidth) g.scrollLeft = Math.max(0, s.offsetLeft - (g.clientWidth - s.offsetWidth) / 2);    updateFade();
  }
  centerSelected();

  /* ---------- clicks, sort, history ---------- */
  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t.closest) return;
    var o = t.closest('[data-t3-sheet-open]');
    if (o) { e.preventDefault(); openSheet(o); return; }
    var c = t.closest('[data-t3-sheet-close]');
    if (c) { e.preventDefault(); closeSheet(); return; }
    var a = t.closest('a[data-t3-nav]');
    if (a && a.href) { e.preventDefault(); go(a.href, a); }
  });

  function sortUrl(form) {
    var u = new URL(form.getAttribute('action') || location.pathname, location.href);
    u.search = '';
    new FormData(form).forEach(function (v, k) {
      if (v === '') return;
      if (k === 'sort_by' && v === form.getAttribute('data-def')) return; // Featured = clean URL
      u.searchParams.append(k, v);
    });
    return u.toString();
  }
  root.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('form[data-t3-sort]');
    if (f && e.target.name === 'sort_by') go(sortUrl(f), q('[data-t3-sortbtn]'));
  });
  root.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-t3-sort]');
    if (f) { e.preventDefault(); go(sortUrl(f), null); }
  });
  /* ---------- Sort button + drop-down panel (TLY STEP 5, 10-26) ----------
     The panel only drives the hidden native select (same name sort_by, same URLs); choosing an option dispatches 'change',
     which the handler above turns into the usual Section Rendering request. The bar is re-rendered on every swap, so
     everything here looks the nodes up fresh and uses delegated listeners. */
  function sortParts() {
    return { btn: q('[data-t3-sortbtn]'), pan: q('[data-t3-sortpanel]'), sel: q('[data-t3-sortsel]') };
  }
  function sortOpen() { var s = sortParts(); return !!(s.pan && !s.pan.hidden); }
  function openSort(focusCur) {
    var s = sortParts();
    if (!s.btn || !s.pan) return;
    s.pan.hidden = false;
    s.btn.setAttribute('aria-expanded', 'true');
    if (focusCur) { var c = s.pan.querySelector('.t3-cur') || s.pan.querySelector('.t3-sopt'); if (c) c.focus(); }
  }
  function closeSort(refocus) {
    var s = sortParts();
    if (!s.btn || !s.pan || s.pan.hidden) return;
    s.pan.hidden = true;
    s.btn.setAttribute('aria-expanded', 'false');
    if (refocus) s.btn.focus();
  }
  function chooseSort(opt) {
    var s = sortParts();
    if (!s.sel || !opt) return;
    var v = opt.getAttribute('data-v');
    var changed = s.sel.value !== v;
    s.sel.value = v;
    closeSort(!changed);
    if (changed) s.sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var b = t.closest('[data-t3-sortbtn]');
    if (b) { e.preventDefault(); if (sortOpen()) closeSort(false); else openSort(false); return; }
    var o = t.closest('.t3-sopt');
    if (o) { e.preventDefault(); chooseSort(o); }
  });
  document.addEventListener('click', function (e) {
    if (!sortOpen()) return;
    if (e.target.closest && e.target.closest('.t3-sortf')) return;
    closeSort(false);
  });
  root.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-t3-sortbtn]')) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openSort(true); }
      else if (e.key === 'Escape' && sortOpen()) { e.preventDefault(); closeSort(true); }
      return;
    }
    var o = t.closest('.t3-sopt');
    if (!o) return;
    var opts = qa('.t3-sopt', o.parentNode), i = opts.indexOf(o);
    if (e.key === 'ArrowDown') { e.preventDefault(); opts[(i + 1) % opts.length].focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); opts[(i + opts.length - 1) % opts.length].focus(); }
    else if (e.key === 'Home') { e.preventDefault(); opts[0].focus(); }
    else if (e.key === 'End') { e.preventDefault(); opts[opts.length - 1].focus(); }
    else if (e.key === 'Escape') { e.preventDefault(); closeSort(true); }
    else if (e.key === 'Tab') { closeSort(false); }
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.t3) go(location.href, null, true);
  });

  /* ---------- phone filter sheet ---------- */
  function sheetEl() { return q('#t3-side'); }
  function focusables() {
    var s = sheetEl();
    return s ? qa('a[href], button, input, select, [tabindex]:not([tabindex="-1"])', s).filter(function (x) { return x.offsetParent !== null; }) : [];
  }
  function openSheet(btn) {
    if (!mq.matches) { var s = sheetEl(); if (s && s.scrollIntoView) s.scrollIntoView(); return; }
    opener = btn;
    root.classList.add('t3-open');
    document.documentElement.classList.add('t3-lock');
    qa('[data-t3-sheet-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var x = q('.t3-x', sheetEl());
    if (x) x.focus();
  }
  function closeSheet() {
    if (!root.classList.contains('t3-open')) return;
    root.classList.remove('t3-open');
    document.documentElement.classList.remove('t3-lock');
    qa('[data-t3-sheet-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var b = q('[data-t3-sheet-open]');
    if (b && b.focus) b.focus();
    opener = null;
  }
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('t3-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!sheetEl().contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  var onMq = function () { if (!mq.matches) closeSheet(); };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
})();
